
import {Component, Vue} from 'vue-property-decorator';
import {IUserProfileUpdate} from '@/interfaces/user';
import {readUserProfile} from '@/store/main/getters';
import {dispatchUpdateUserProfile} from '@/store/main/actions';

@Component
export default class UserProfileEdit extends Vue {
  public valid = true;
  public fullName: string = '';
  public email: string | undefined = '';
  public password1 = '';
  public password2 = '';

  public created() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      this.fullName = userProfile.fullname;
      this.email = userProfile.email;
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public reset() {
    this.password1 = '';
    this.password2 = '';
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      this.fullName = userProfile.fullname;
      this.email = userProfile.email;
    }
    this.$validator.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if ((this.$refs.form as any).validate()) {
      const updatedProfile: IUserProfileUpdate = {};
      if (this.fullName) {
        updatedProfile.fullname = this.fullName;
      }
      if (this.email) {
        updatedProfile.email = this.email;
      }
      if (this.password1) {
        updatedProfile.password = this.password1;
      }
      await dispatchUpdateUserProfile(this.$store, updatedProfile);
      this.$router.push('/main/profile');
    }
  }
}
